module.exports = __webpack_public_path__ + "8ecffb1462e12575029c4a19ce0709ac.jpg";